import React from 'react';
import PropTypes from 'prop-types';

import { SelectBox } from 'components/core/SelectBox';

// REDUX-FORM SELECT BOX
export default function ReduxSelectBox({
	className,
	input,
	label,
	meta,
	disabled,
	options,
	id,
	errorMessage,
	isModal,
}) {
	return (
		<SelectBox
			{...input}
			id={id}
			label={label}
			className={className}
			valid={meta.valid}
			options={options}
			disabled={disabled}
			reduxFormError={meta.touched && meta.invalid}
			errorMessage={errorMessage}
			isModal={isModal}
		/>
	);
}

ReduxSelectBox.propTypes = {
	input: PropTypes.object,
	label: PropTypes.node,
	className: PropTypes.string,
	meta: PropTypes.object,
	disabled: PropTypes.bool,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.any,
			display: PropTypes.string,
		}),
	),
	id: PropTypes.string,
	value: PropTypes.string,
	errorMessage: PropTypes.string,
	isModal: PropTypes.bool,
};
